import { render, staticRenderFns } from "./SubscriptionFormScreen.vue?vue&type=template&id=1565da1a&"
import script from "./SubscriptionFormScreen.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionFormScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports